<p-toast position="top-right" />

<p-confirmdialog>
  <ng-template pTemplate="headless" let-confirmation let-onAccept="onAccept" let-onReject="onReject">
    <div class="jl-confirm-dialog">
      <h2 class="jl-confirm-title">{{ confirmation.header }}</h2>

      @if (confirmation.message) {
        <p class="jl-confirm-description">{{ confirmation.message }}</p>
      }

      @if (confirm.alert(); as alert) {
        <div class="jl-confirm-alert jl-confirm-alert--{{ alert.severity }}">
          <lucide-icon [img]="alertIcons[alert.severity]" [size]="16" class="jl-confirm-alert__icon" />
          <div class="jl-confirm-alert__content">
            <div class="jl-confirm-alert__title">{{ alert.title }}</div>
            @if (alert.description) {
              <div class="jl-confirm-alert__description">{{ alert.description }}</div>
            }
          </div>
        </div>
      }

      <div class="jl-confirm-actions">
        @if (confirmation.rejectVisible !== false) {
          <button
            pButton
            type="button"
            [label]="confirmation.rejectLabel"
            [class]="confirmation.rejectButtonStyleClass"
            (click)="onReject()"
          ></button>
        }
        <button
          pButton
          type="button"
          [label]="confirmation.acceptLabel"
          [class]="confirmation.acceptButtonStyleClass"
          (click)="onAccept()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-confirmdialog>

<router-outlet />

<app-global-drop-zone-overlay />
<app-upload-confirm-modal />

<div class="jl-tracker-stack">
  <app-upload-tracker />
  <app-download-tracker />
</div>

@if (demoMode.active()) {
  <app-demo-overlay />
}
